import React from 'react';
import styled from 'styled-components';

const StatsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin: 0 0 0.75rem;
`;

const StatsLine = styled.span`
  font-size: 0.85rem;
  color: var(--text-secondary, #64748b);
  line-height: 1.45;
`;

const SellerStatsLabels = ({ successfulSales, memberSinceYear }) => {
  const salesValue = successfulSales == null ? null : Number(successfulSales);
  const yearValue = memberSinceYear == null ? null : Number(memberSinceYear);

  if (salesValue == null && (yearValue == null || Number.isNaN(yearValue))) {
    return null;
  }

  const salesLine =
    salesValue != null && !Number.isNaN(salesValue)
      ? salesValue > 0
        ? `This user has already sold ${salesValue} before on Flea.`
        : "This user hasn't sold anything yet"
      : null;

  return (
    <StatsWrap>
      {salesLine ? <StatsLine>{salesLine}</StatsLine> : null}
      {yearValue != null && !Number.isNaN(yearValue) ? (
        <StatsLine>Member Since {yearValue}</StatsLine>
      ) : null}
    </StatsWrap>
  );
};

export default SellerStatsLabels;
